import { useState, useEffect } from 'react';

const LEGACY_PORTAL_MODE_KEY = 'LEGACY_PORTAL_MODE';

export const getLegacyPortalMode = () => {
  const mode = localStorage.getItem(LEGACY_PORTAL_MODE_KEY);
  return mode === 'true';
};

const setLegacyPortalMode = (isLegacy) => {
  localStorage.setItem(LEGACY_PORTAL_MODE_KEY, isLegacy.toString());
};

export const useLegacyMode = (initialState = true) => {
  const [isLegacyMode, setIsLegacyMode] = useState(() => {
    // Initialize from localStorage if available, otherwise use initialState
    return getLegacyPortalMode() ?? initialState;
  });
  const [keySequence, setKeySequence] = useState([]);
  const [touchCount, setTouchCount] = useState(0);
  const [firstTouchTime, setFirstTouchTime] = useState(0);

  // Update localStorage when isLegacyMode changes
  useEffect(() => {
    setLegacyPortalMode(isLegacyMode);
  }, [isLegacyMode]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Check for Ctrl + Alt + A
      if (event.ctrlKey && event.altKey && event.keyCode === 65) {
        setKeySequence(['a']);
      }
      // Check for Ctrl + Alt + D
      else if (event.ctrlKey && event.altKey && event.keyCode === 68) {
        if (keySequence[0] === 'a') {
          setIsLegacyMode((prev) => !prev);
          setKeySequence([]);
        }
      }
      // Reset sequence if modifiers are released
      else if (!event.ctrlKey || !event.altKey) {
        setKeySequence([]);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [keySequence]);

  const handleTouch = () => {
    const now = Date.now();

    // If this is the first touch or we're outside the 5-second window
    if (touchCount === 0 || now - firstTouchTime > 5000) {
      setFirstTouchTime(now);
      setTouchCount(1);
    } else {
      const newCount = touchCount + 1;
      setTouchCount(newCount);

      if (newCount >= 5) {
        setIsLegacyMode((prev) => !prev);
        setTouchCount(0);
        setFirstTouchTime(0);
      }
    }
  };

  const toggleLegacyMode = () => {
    setIsLegacyMode((prev) => !prev);
  };

  return {
    isLegacyMode,
    toggleLegacyMode,
    handleTouch,
  };
};
